import { atomWithReset } from 'jotai/utils';
import { ClickPosition, ClickPositionPrefix } from '~/utils/click-position';

interface IPopupContent {
  description: string;
  buttonOpen: string;
}
interface SimpleCtaModalProps {
  body: string;

  currentPosition: ClickPosition | [ClickPositionPrefix, ClickPosition];
  pageClickId?: string;

  handleClickConfirm: () => void;
  handleClickCancel?: () => void;
  popupContent?: IPopupContent;

  additionalParams?: Record<string, unknown>;
}

export const $SimpleCTAModalShow = atomWithReset<SimpleCtaModalProps | false>(false);
